export const STATUUT_STYLES = {
    freelance: { label: 'Freelance', cls: 'bg-gray-100 text-gray-700' },
    interim: { label: 'Interim', cls: 'bg-purple-100 text-purple-800' },
    student: { label: 'Student', cls: 'bg-blue-100 text-blue-800' },
    flexi_job: { label: 'Flexi-job', cls: 'bg-yellow-100 text-yellow-800' },
};

export const statuutLabel = (statuut) => STATUUT_STYLES[statuut]?.label ?? statuut;
